import { ApolloClient, InMemoryCache } from '@apollo/client'

// import { ApolloClient, InMemoryCache, split } from '@apollo/client'
import { createUploadLink } from 'apollo-upload-client'
import { onError } from "@apollo/client/link/error";
import { setContext } from '@apollo/client/link/context';
import { ERROR_MESSAGE_TYPE, LOCAL_STORAGE_KEY } from '../global/enums'
// import { getMainDefinition } from '@apollo/client/utilities'; */
// import { WebSocketLink } from '@apollo/client/link/ws';

const errorLink = onError(({ graphQLErrors, networkError, operation, forward }) => {

  if (graphQLErrors) {

    for (let err of graphQLErrors) {

      if (err && err.type && err.type === ERROR_MESSAGE_TYPE) {

        const item = localStorage.getItem(LOCAL_STORAGE_KEY)

        if (item) {
          if (err.code === 1110 || err.code === 1200) {
            localStorage.removeItem(LOCAL_STORAGE_KEY)
            window.location.reload();
          }
        }

        return forward(operation);
        
      }

      return forward(operation)

    }

  }

  if (networkError) console.log(`[Network error]: ${networkError}`);

});

let authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem(LOCAL_STORAGE_KEY);
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token || '',
    }
  }
}).concat(errorLink).concat(createUploadLink({
  uri: process.env.REACT_APP_API || 'http://localhost:9000/api'
}));

/* const wsLink = new WebSocketLink({
  uri: process.env.REACT_APP_WS || 'ws://localhost:9000/subscriptions',
  options: {
    reconnect: true,
    timeout: 5000,
  }
}); */

/* const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return (
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
    );
  },
  wsLink,
  authLink,
); */

const client = new ApolloClient({
  connectToDevTools: true,
  cache: new InMemoryCache(),
  link: authLink
});

export default client;